import * as React from 'react';
import { DATA_HOOKS } from './constants';
import { TPAComponentsConsumer } from '../TPAComponentsConfig';
import { Modal } from '../internal/Modal';
import { IconButton } from '../IconButton';
import { Close } from '@wix/wix-ui-icons-common/on-stage';
import { st, classes } from './Dialog.deprecated.st.css';
/** Dialog */
export class Dialog extends React.Component {
    render() {
        const { className, isOpen, manualFocus, closeButtonRef, onClose, children, contentClassName, childrenWrapperClassName, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-describedby': ariaDescribedBy, closeButtonAriaLabel, closeButtonAriaLabelledby, wiredToSiteColors, notFullscreenOnMobile, appendToBody, forceBWTheme, } = this.props;
        return (React.createElement(TPAComponentsConsumer, null, ({ mobile, rtl }) => {
            const wrapperClassName = st(classes.root, {
                mobile,
                rtl,
                wired: wiredToSiteColors,
                notFullscreenMobile: mobile && notFullscreenOnMobile,
            }, classes[`skin-${wiredToSiteColors ? 'wired' : 'fixed'}`], className);
            return (React.createElement("div", { className: appendToBody ? undefined : wrapperClassName, "data-hook": this.props['data-hook'], "data-mobile": mobile },
                React.createElement(Modal, { isOpen: isOpen, focusTrap: !manualFocus, onRequestClose: onClose, forceBWTheme: forceBWTheme && !wiredToSiteColors, appendToBody: appendToBody, className: appendToBody ? wrapperClassName : undefined },
                    React.createElement("div", { className: st(classes.outerContentWrapper, { appendToBody }) },
                        React.createElement("div", { className: `${classes.contentWrapper} ${contentClassName || ''}`, role: "dialog", "aria-modal": "true", "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy },
                            React.createElement("div", { className: classes.closeButtonWrapper },
                                React.createElement(IconButton, { className: classes.closeIconButton, "data-hook": DATA_HOOKS.CLOSE_BTN, "aria-label": closeButtonAriaLabel, "aria-labelledby": closeButtonAriaLabelledby, innerRef: closeButtonRef, onClick: onClose, icon: React.createElement(Close, null) })),
                            React.createElement("div", { className: `${classes.dialogContent} ${childrenWrapperClassName || ''}` }, children))))));
        }));
    }
}
Dialog.displayName = 'Dialog';
Dialog.defaultProps = {
    isOpen: false,
    manualFocus: false,
    notFullscreenOnMobile: false,
};
//# sourceMappingURL=Dialog.js.map